"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var theme = _a.theme, rowGap = _a.rowGap;
    if (!rowGap) {
        return '';
    }
    return "row-gap: " + theme.sizes.default[rowGap] + ";";
});
